import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import get from 'lodash/get';
import ElementQueries from '../../../ElementQueries';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import { DndSortable, DndSortableElement } from '../../../Dnd/DndSortable';
import { DraggableType } from '../../../types/dnd';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withFileUpload from '../../_hocs/withFileUpload';
import { MediaSourceType } from '../../types';
import { getCanEditGallection, isSpecialFullyLockedFolder } from '../../helpers';
import UploadThumb from '../../_partials/UploadThumb';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import s from './DeviationGrid.scss';
const enhance = compose(withFileUpload, withCurrentMediaSource, withCurrentGallection);
export class DeviationGrid extends React.Component {
    shouldComponentUpdate(nextProps) {
        // We need to update the component if either the deviation or fileUploads
        // array has changed.
        if (nextProps.deviations.length !== this.props.deviations.length || nextProps.fileUploads.length !== this.props.fileUploads.length) {
            return true;
        }
        // If the deviations array has different deviationIds
        const deviationsDidUpdate = !!nextProps.deviations.find((deviation, index)=>deviation.deviationId !== get(this, `props.deviations[${index}].deviationId`));
        // ...or if the files that are currently uploading have different fileIds
        // or different progress, we need to  re-render the file upload thumb
        const fileUploadsDidUpdate = !!nextProps.fileUploads.find((fileUpload, index)=>fileUpload.fileId !== get(this, `props.fileUploads[${index}].fileId`) || fileUpload.progress !== get(this, `props.fileUploads[${index}].progress`));
        return deviationsDidUpdate || fileUploadsDidUpdate;
    }
    render() {
        return /*#__PURE__*/ React.createElement(DndSortable, {
            onDrop: this.onDndDrop,
            onDragOver: this.onDndDragOver
        }, (props)=>/*#__PURE__*/ React.createElement(ElementQueries, {
                widthBreakpoints: [
                    1100,
                    800,
                    700,
                    450
                ],
                className: s['grid']
            }, [
                ...this.props.fileUploads.sort((a, b)=>a.fileId - b.fileId).map(this.renderFileUpload),
                ...this.props.deviations.map(this.renderDndDeviation(props))
            ]));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderDndDeviation", (_param)=>{
            var { draggedElementId } = _param, dndProps = _object_without_properties(_param, [
                "draggedElementId"
            ]);
            return (deviation, index)=>{
                const { currentMediaSource, currentGallection, deviationRenderer, deviations, moveDeviationToPosition } = this.props;
                const isDragging = draggedElementId === deviation.deviationId;
                let areDeviationsSortable = false;
                if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
                    areDeviationsSortable = true;
                } else if (currentMediaSource && [
                    MediaSourceType.TIER_DEVIATIONS,
                    MediaSourceType.TIER_POSTS
                ].includes(currentMediaSource)) {
                    areDeviationsSortable = false;
                } else {
                    areDeviationsSortable = !!moveDeviationToPosition && !!currentGallection && getCanEditGallection(currentGallection) && !isSpecialFullyLockedFolder(currentGallection);
                }
                const entityId = getDeviationEntityId(deviation);
                return /*#__PURE__*/ React.createElement(DndSortableElement, _object_spread({
                    dndType: DraggableType.MEDIA_MANAGER_DEVIATION,
                    id: entityId,
                    key: entityId,
                    position: index,
                    isSortable: areDeviationsSortable
                }, dndProps), (options)=>/*#__PURE__*/ React.createElement("div", {
                        className: classnames(s['grid-item'], isDragging && s['dragging']),
                        ref: options.ref
                    }, deviationRenderer(deviation, index, deviations)));
            };
        });
        _define_property(this, "renderFileUpload", (fileUpload)=>{
            const { currentGallection } = this.props;
            const { file, fileId, folderId, progress, error } = fileUpload;
            if (!file || !currentGallection || currentGallection.folderId !== folderId || currentGallection.type !== MediaSourceType.STASH) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(UploadThumb, {
                key: `upload-${fileId}`,
                className: s['grid-item'],
                file: file,
                progress: progress,
                error: error
            });
        });
        _define_property(this, "findDeviationByEntityId", (entityId)=>this.props.deviations.find((deviation)=>getDeviationEntityId(deviation) === entityId));
        _define_property(this, "onDndDrop", (entityId, position)=>{
            const deviation = this.findDeviationByEntityId(entityId);
            if (deviation) {
                this.props.moveDeviationToPosition({
                    deviation,
                    position,
                    moveType: 'papiOnly'
                });
            }
        });
        _define_property(this, "onDndDragOver", (entityId, position)=>{
            const deviation = this.findDeviationByEntityId(entityId);
            if (deviation) {
                this.props.moveDeviationToPosition({
                    deviation,
                    position,
                    moveType: 'streamOnly'
                });
            }
        });
    }
}
export default enhance(DeviationGrid);
